var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-header panel-header-lg"},[_c('header-chart',{attrs:{"height":255,"chart-data":_vm.chartData,"options":_vm.optionsArr}}),_c('canvas',{attrs:{"id":"canvasMaluco"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }